<template lang="pug">

  .product-payment-form-component
    h3.section-title Select amount
    .row.cart-row
      .col-lg-6
        form-group-row(:form='form', :label="$t('buy_cards.value')", name='product')
          v-select.form-control(v-model="product", label="text", :options="products || []", :searchable="false")
      .col-lg-3
        form-group-row(:form='form', :label="quantityLabel", name='quantity')
          v-select.form-control(v-model="quantity", label="value", :options="quantityOptions()", :searchable="false")
      .col-lg-3.text-right
        .form-group
          label &nbsp;
          .add-to-cart
            button.btn.btn-primary(type="button", @click="addToCart", :disabled="!product || !quantity") {{ 'Add to cart' }}
    template(v-if="products")
      .row.added-product(v-for="(value, key) in selectedProducts", :key="key")
        .col-lg-6 {{ products.find(p => p.value == key).text }}
        .col-lg-2.text-lg-right {{ value }}
        .col-lg-4.text-lg-right
          button.btn.btn-primary(type="button", @click="removeFromCart(key)") Remove
    .row(v-if="locationAtPurchase")
      .col-lg-6
        form-group-row(:form='form', :label="$t('buy_cards.location')", name='location_id')
          v-select.form-control(v-model="location", :on-change="changeLocation", label="title", :options="locations", :searchable="false", :class="{'is-invalid': form.errors.has('location_id')}")
    hr.under-cart
    .row
      .col-lg-6
    .row
      .col-lg-6.coupon-block
        form-group-row(:form='form', :label="$t('payment_form.coupon')", name='coupon')
          form-input(:form='form', name='coupon')
        button.btn.btn-primary(type="button", @click="updateTotal") Add promo code
      .col-lg-6.summary-block
        .row.subtotal-row
          .col-lg-6.text-right Subtotal
          .col-lg-6.text-right {{ subtotal | currency('$') }}
        .row.coupon-row
          .col-lg-6.text-right Promo code
          .col-lg-6.text-right -{{ discount | currency('$') }} 
            span.coupon-percentage ({{ discountPercentage }}%)
        .row.tax-row
          .col-lg-6.text-right Tax
          .col-lg-6.text-right {{ tax | currency('$') }}
        .row.total-row
          .col-lg-6.text-right Total
          .col-lg-6.text-right {{ total | currency('$') }}
    hr.under-total
    h3.section-title Billing information
    payment-form(:form='form')

</template>

<script>
import LocationService from '../services/location';
import ProductService from '../services/product';
import { mapGetters } from 'vuex'
import Form from 'vform';

export default {
  name: 'product-payment-form',

  props: {
    form: {
      type: Form,
      required: true
    },
    quantityLabel: {
      type: String,
      default: '# of cards'
    }
  },

  data: () => ({
    locationAtPurchase: null,
    locations: [],
    location: null,
    products: null,
    product: null,
    quantity: null,
    subtotal: 0,
    total: 0,
    tax: 0,
    discount: 0,
    discountPercentage: 0
  }),

  computed: {
    bonus: function () {
      if (this.product && this.products) {
        const pakkage = this.products.find(p => p.value == this.product.value);
        if (this.locationAtPurchase) {
          if (this.location) {
            const product = pakkage.products.find(p => p.location_id == this.location.id);
            return Number(product.play_bonus_added);
          }
        } else {
          const product = pakkage.product;
          return Number(product.play_bonus_added);
        }
      }
    },
    ...mapGetters({
      selectedProducts: 'products'
    })
  },

  async created() {
    this.locationAtPurchase = window.addiesaas.config.locationAtPurchase;

    if (this.locationAtPurchase) {
      this.locations = await LocationService.index();

      if (this.form.location_id) {
        this.location = this.locations.find(x => x.id == this.form.location_id);
      }
    }

    const products = await ProductService.index();
    this.products = products.map(p => p.data).map(p => ({ value: p.id, text: p.title, price: p.price, tax: p.tax }));

    this.updateTotal();
  },

  methods: {
    quantityOptions() {
      return [...Array(10).keys()].map(x => ({value: (x + 1).toString()}));
    },

    addToCart() {
      const quantity = this.quantity.value;
      this.$store.dispatch('addProduct', { productId: this.product.value, quantity })
      this.updateTotal();

      this.product = null;
      this.quantity = null;
    },

    removeFromCart(productId) {
      this.$store.dispatch('removeProduct', { productId })
      this.updateTotal();
    },

    async updateTotal() {
      Object.assign(this.form.product, this.$store.state['pay/invoices'].products);
      let {data} = await this.form.post(`${window.addiesaas.url}/api/invoices/calculate`);
      data = data.data;
      this.subtotal = data.price;
      this.discount = data.price_discount || 0;
      this.tax = data.tax - (data.tax_discount || 0);
      this.total = data.total;
      this.discountPercentage = (this.subtotal ? this.discount / this.subtotal * 100 : 0).toFixed();
    },

    changeLocation(e) {
      this.location = e;
      this.form.location_id = e ? e.id : null;
      this.updateTotal();
    }
  },
}
</script>
